export const V1_REMOVE_SEAT_TRADE_NOTIFICATION =
  'V1_REMOVE_SEAT_TRADE_NOTIFICATION'

export default data => {
  return {
    type: V1_REMOVE_SEAT_TRADE_NOTIFICATION,
    data,
  }
}
